module.exports = __webpack_public_path__ + "media/images/mv_h1_about_sp-86aa4ec850a44be81cb7fd179848060d.png";